'use strict';

var GridRemoveCalendarButtonDirective = function GridRemoveCalendarButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-remove-calendar-button.html'),
    controller: 'GridRemoveCalendarButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridRemoveCalendarButtonDirective.$inject = [];
module.exports = GridRemoveCalendarButtonDirective;